<template>
  <div class="case-diff-tool new-globals">
    <div class="selector-container">
      <user-case-selector
        title="Case 1"
        :single-select="true"
        @envSelected="updateFromEnv"
        @orgSelected="updateSelectedFromOrg"
        @userSelected="updateSelectedFromUser"
        @casesSelected="updateFromCase"
      />
    </div>
    <div class="selector-container">
      <user-case-selector
        title="Case 2"
        :loading="diffing"
        :single-select="true"
        @envSelected="updateToEnv"
        @orgSelected="updateSelectedToOrg"
        @userSelected="updateSelectedToUser"
        @casesSelected="updateToCase"
      />
      <md-button
        class="md-primary md-raised diff-button"
        :disabled="diffing || !state.selectedFromOrg || !state.selectedToOrg || !state.selectedFromUser || !state.selectedToUser || !state.selectedFromCaseId || !state.selectedToCaseId"
        @click="diff"
      >
        Diff
      </md-button>
    </div>

    <span v-if="error && error.code !== 'CASE_JSON_NOT_EQUAL'" class="error">{{
      error.message || error.error || error
    }}</span>
    <md-card v-if="error && error.code === 'CASE_JSON_NOT_EQUAL'" class="case-json-diff-container">
      <md-card-header>
        <div class="md-title">Case Diff - {{ JSON.parse(error.fromCaseJson).name }}</div>
      </md-card-header>
      <md-card-content>
        <code-diff class="code-diff" :old-string="error.fromCaseJson" :new-string="error.toCaseJson" />
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual'
import sortBy from 'lodash/sortBy'
import CodeDiff from 'vue-code-diff'
import UserCaseSelector from '../UserCaseSelector';

export default {
  name: 'case-diff-tool',
  components: {
    CodeDiff,
    UserCaseSelector,
  },
  props: {
    fromEnv: {
      type: String,
      default: 'dev'
    },
    toEnv: {
      type: String,
      default: 'dev'
    },
    fromOrgs: {
      type: Array,
      default: () => []
    },
    fromCases: {
      type: Array,
      default: () => []
    },
    fromUsers: {
      type: Array,
      default: () => []
    },
    toOrgs: {
      type: Array,
      default: () => []
    },
    toUsers: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    diffing: {
      type: Boolean,
      default: false
    },
    error: {
      type: [Error, Object],
      default: null
    }
  },
  data() {
    return {
      state: {
        selectedFromOrg: null,
        selectedFromUser: null,
        selectedToOrg: null,
        selectedToUser: null,
        selectedFromCaseId: null,
        selectedToCaseId: null,
        searchTerm: '',
      }
    };
  },
  computed: {
    fromUsersWithLabel() {
      return this.fromUsers.map(user => ({
        ...user,
        label: this.userLabel(user)
      }))
    },
    toUsersWithLabel() {
      return this.toUsers.map(user => ({
        ...user,
        label: this.userLabel(user)
      }))
    },
    filteredCases() {
      if (this.state.searchTerm) {
        return this.fromCases.filter(caseConf => 
          caseConf.name
            .toLowerCase()
            .includes(this.state.searchTerm.trim().toLowerCase())
        );
      }
      return this.fromCases;
    },
    isAllCases: {
      get() {
        const selectedIds = sortBy(this.state.selectedCaseIds);
        const filteredIds = sortBy(this.filteredCases.map(caseConf => caseConf.id));
        return isEqual(selectedIds, filteredIds);
      },
      set() {
        if (this.isAllCases) {
          this.unselectAllCases();
        } else {
          this.selectAllCases();
        }
      },
    },
  },
  watch: {
    diffing(newVal, oldVal) {
      // Reset the selected case when diffing is successful
      if (!newVal && oldVal && !this.error) {
        alert('No diff between those 2 cases. Their data are the same.');
        this.state.selectedCaseIds = null;
      }
    }
  },
  methods: {
    userLabel(user) {
      if (user.given_name || user.family_name) {
        return `${user.given_name || ''} ${user.family_name || ''}`;
      }
      return user.email;
    },
    updateFromEnv(env) {
      this.$emit('updateFromEnv', env);
    },
    updateToEnv(env) {
      this.$emit('updateToEnv', env);
    },
    updateSelectedFromOrg(org) {
      this.state.selectedFromOrg = org;
    },
    updateSelectedFromUser(user) {
      this.state.selectedFromUser = user;
    },
    updateSelectedToUser(user) {
      this.state.selectedToUser = user;
    },
    updateSelectedToOrg(org) {
      this.state.selectedToOrg = org;
    },
    updateFromCase(caseIds) {
      this.state.selectedFromCaseId = caseIds[0];
    },
    updateToCase(caseIds) {
      this.state.selectedToCaseId = caseIds[0];
    },
    diff() {
      this.$emit(
        'diff',
        this.state.selectedFromCaseId,
        this.state.selectedToCaseId,
        this.state.selectedFromOrg,
        this.state.selectedToOrg,
        this.state.selectedFromUser,
        this.state.selectedToUser,
      );
    }
  }
};
</script>

<style scoped>
.case-diff-tool {
  display: flex;
}

.selector-container {
  display: inline-block;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.selection-card {
  max-width: 400px;
}

.error {
  color: red;
}

.case-json-diff-container {
  flex: 1;
  max-width: 80%;
}

.diff-button {
  margin-right: 16px;
}

.case-json-diff-container {
  max-width: 600px;
}

.code-diff {
  max-width: 100%;
  height: 500px !important;
  overflow: auto;
}
</style>